import React, { useState } from "react";
import { Direction } from "../Models";
import { Alert, Button } from "react-bootstrap";
import { SpinnerSmall } from "../../Shared/Components/Spinner";
import { getApiCallState, useStateSelector } from "./Model";
import { RouteMap } from "../TravelDetails/TravelDetails";
import { BookTableModal } from "./BookTableModal";
import { findRelevantLeg } from "./App";
import dayjs from "dayjs";


export const SearchResult = () => {
	const state = useStateSelector(state => state.booking);
	const apicalls = getApiCallState();
	const searchState = apicalls.getLoadingState("searchJourney");

	if (!state.travels)
		return null;

	return <>
		{ searchState === "loading" && <Alert variant="info">Search in progress... <SpinnerSmall /></Alert> }
		{ searchState === "error" && <Alert variant="danger">Timetable search failed, check your search parameters</Alert> }

		{ searchState === "loaded" && <>
			<h3 className="mt-0">Outbound, {state.departureDate}</h3>
			<Travel direction="outbound" />
			<hr />
			<h3 className="mt-3">Return, {state.returnDate}</h3>
			<Travel direction="inbound" />
		</>}
	</>
}

const Travel = (props: { direction: Direction }) => {
	const travel = useStateSelector(state => state.booking.travels?.find(x => x.direction === props.direction));
	const tableBookings = useStateSelector(state => state.booking.tableBookings);
	const customerDetails = useStateSelector(state => state.booking.customerDetails);

	const [showDinnerModal, setShowDinnerModal] = useState(false);
	const [showLunchModal, setShowLunchModal] = useState(false);

	if (!travel || !travel.routes?.length)
		return <Alert variant="warning">No departures this day</Alert>

	const route = travel.routes[0]; //Behöver vi ha smartare val?
	const leg = findRelevantLeg(travel);
	const showLunchButton = leg?.arrivalStation && dayjs(leg.arrivalStation.arrivalTimestamp).hour() >= 11;

	const lunchBooking = tableBookings?.find(x => x.travelId === travel?.id && x.slot === "lunch");
	const dinnerBooking = tableBookings?.find(x => x.travelId === travel?.id && x.slot === "dinner");

	return <>
		<RouteMap route={route} />

		<h5 className="mb-1 mt-3">Dinner</h5>
		{ dinnerBooking ? <p>
			Table booked at {dinnerBooking.arrival} for {dinnerBooking.persons} person(s)
		</p> : <>
			No table booking<br />
			<Button variant="outline-primary" size="sm" onClick={() => setShowDinnerModal(true)} disabled={!customerDetails} title={!customerDetails ? "Fill in customer details first" : ""}>Book dinner</Button>
		</>}
		<BookTableModal show={showDinnerModal} slot="dinner" travel={travel} onClosed={() => setShowDinnerModal(false)} />

		{ showLunchButton && <>
			<h5 className="mb-1 mt-3">Lunch</h5>
			{ lunchBooking ? <p>
				Table booked at {lunchBooking.arrival} for {lunchBooking.persons} person(s)
			</p> : <>
				No table booking<br />
				<Button variant="outline-primary" size="sm" onClick={() => setShowLunchModal(true)} disabled={!customerDetails} title={!customerDetails ? "Fill in customer details first" : ""}>Book lunch</Button>
			</>}
			<BookTableModal show={showLunchModal} slot="lunch" travel={travel} onClosed={() => setShowLunchModal(false)} />
		</>}
	</>;
}
